export default "__VITE_ASSET__aTGCHmYI__"